import React from 'react';
import { Button } from 'react-bootstrap';
import { Confirm, ICONS } from '../../../components';
import { Organization } from './types';

interface Props {
  organization: Organization;
  onConfirm: () => void;
}

export const TokenLocationConfirm: React.FC<Props> = ({ organization, onConfirm }) => (
  <div style={{ marginTop: '40vh', marginLeft: '45vw' }}>
    <Confirm
      onConfirm={onConfirm}
      confirmText="Send"
      confirmBSStyle="danger"
      title="Confirm Token Display Location"
      body={
        <>
          <h4>These Tokens are valid only for </h4>
          <h6>
            {organization.name}, {organization.address}, {organization.city}, {organization.state}
          </h6>
        </>
      }
    >
      <Button size="lg" variant="dark">
        {ICONS.REFRESH} Click to confirm token display location
      </Button>
    </Confirm>
  </div>
);
